import { TranslateModule } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
import { IconButtonComponent } from 'shared';
import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AuthService } from '../../../auth/auth.service';
import { NavMenuItem, shouldShowNavItem } from '../nav.component';

@Component({
  selector: 'app-nav-mobile',
  imports: [IconButtonComponent, FeatherModule, TranslateModule, RouterLink],
  templateUrl: './nav-mobile.component.html',
  styleUrl: './nav-mobile.component.scss',
})
export class NavMobileComponent {
  menuItems = input<NavMenuItem[]>([]);

  isMobileMenuOpen = false;
  openDropdowns = new Set<number>();

  private authService = inject(AuthService);

  shouldShowItem(item: NavMenuItem): boolean {
    return shouldShowNavItem(item, this.authService.isAuthenticated());
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    // Close all dropdowns when menu is closed
    if (!this.isMobileMenuOpen) {
      this.openDropdowns.clear();
    }
  }

  toggleDropdown(index: number) {
    if (this.openDropdowns.has(index)) {
      // Close the clicked dropdown
      this.openDropdowns.delete(index);
    } else {
      // Close all other dropdowns and open the clicked one
      this.openDropdowns.clear();
      this.openDropdowns.add(index);
    }
  }

  isDropdownOpen(index: number): boolean {
    return this.openDropdowns.has(index);
  }
}
